var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShowHideThumbnailViewSmallIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 26 26",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h26v26H0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlighted-path",
  d: "M16.6 15.8V20c0 .336.264.6.6.6h3.6c.336 0 .6-.264.6-.6v-4.2c0-.336-.264-.6-.6-.6h-3.6c-.336 0-.6.264-.6.6zm-6 4.2v-4.2c0-.336.264-.6.6-.6h3.6c.336 0 .6.264.6.6V20c0 .336-.264.6-.6.6h-3.6a.594.594 0 0 1-.6-.6zm-1.8-4.8H5.2c-.336 0-.6.264-.6.6V20c0 .336.264.6.6.6h3.6c.336 0 .6-.264.6-.6v-4.2c0-.336-.264-.6-.6-.6z",
  fillOpacity: 0.5,
  fill: "#AA2FF0"
}), /*#__PURE__*/React.createElement("path", {
  className: "highlighted-path",
  fill: "#AA2FF0",
  d: "m12.997 5.343 4.628 7.714H8.368z"
}))));
export default SvgShowHideThumbnailViewSmallIcon;